"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var Button_1 = require("../Button");
var Container_1 = __importDefault(require("../Container"));
require("./ActionBar.scss");
var ActionBarBumper = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: "action-bar-bumper" }, children));
};
exports.ActionBarBumper = ActionBarBumper;
var ActionBar = function (props) {
    var container = react_1.useState(document.createElement('div'))[0];
    var primary = props.primary, secondary = props.secondary, cancel = props.cancel;
    react_1.useEffect(function () {
        document.body.appendChild(container);
        return function () {
            document.body.removeChild(container);
        };
    }, []);
    return react_dom_1.default.createPortal(react_1.default.createElement("div", { className: "w-full bg-white border-t border-gray-light shadow-reverse fixed left-0 bottom-0 right-0 z-50" },
        react_1.default.createElement("div", { className: "p-8" },
            react_1.default.createElement(Container_1.default, { className: "flex justify-between" },
                react_1.default.createElement("div", { className: "" }, cancel && (react_1.default.createElement(Button_1.DangerButton, { processing: cancel.processing, onClick: cancel.action }, cancel.label))),
                react_1.default.createElement("div", { className: "flex-grow text-right" },
                    secondary && (react_1.default.createElement(Button_1.WhiteButton, { processing: secondary.processing, onClick: secondary.action }, secondary.label)),
                    primary && (react_1.default.createElement(Button_1.Button, { processing: primary.processing, form: primary.form, className: "ml-8", onClick: primary.action ? primary.action : function () { }, type: primary.action ? Button_1.ButtonType.button : Button_1.ButtonType.submit }, primary.label)))))), container);
};
exports.default = ActionBar;
//# sourceMappingURL=ActionBar.js.map